export default function GuestHostSection() {
  return (
    <section className="relative bg-[#FFFBF4] px-6 lg:px-20 py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto text-left">
        <p className="text-xs tracking-[0.35em] text-[#565449] mb-4">
          WRITING JOURNEY OF <span className="italic">WHEN THE SHADOWS SPOKE</span>
        </p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#11120D] mb-8">
          Writing Journey of <span className="italic">When the Shadows Spoke</span>
        </h2>
        <div className="text-[#565449] leading-relaxed space-y-6 text-[1.14rem]">
          <p>
            This story began as a thriller, but it soon revealed something far more delicate and human. I wasn’t only interested in the crime — I was drawn to what it does to the people who stand in its shadow. To the quiet weight carried by those who protect others, who choose truth again and again, even when it costs them everything and no one ever sees the price they pay.
          </p>
          <p>
            Arjun was never meant to be a loud or flawless hero. He is a man who does his duty while carrying questions he cannot answer, wounds he cannot name, and a moral courage that refuses to break — even when the world around him asks him to look away. Reema carries her own kind of strength, softer yet just as fierce — a resilience shaped by loss, silence, and the long journey of staying human in a world that often forgets how.
          </p>
          <p>
            Through them, I wanted you to feel what heroes rarely reveal:<br />
            <span className="block ml-4">
              the tiredness behind their bravery,<br />
              the loneliness behind their discipline,<br />
              the fear that lives quietly beneath their unshakable sense of right and wrong.
            </span>
          </p>
          <p>
            I wanted you to feel how difficult it is to remain honest in a world that rewards obedience more than truth — and how much courage it takes to keep choosing what is right, even when it leaves you standing alone.
          </p>
          <p>
            There were moments when this story flowed gently, and others when it unsettled me, because <span className="italic">When the Shadows Spoke</span> is not really about secrets or conspiracies. It is about people who keep showing up for life, even when parts of their own story have been taken from them.
          </p>
          <p>
            This book taught me that silence is never empty — it is full of things left unsaid. And that the bravest souls are often the ones who fight their battles quietly, without recognition, without applause.
          </p>
          <p>
            I wrote this story for those who still believe that truth matters.<br />
            <span className="block ml-4">
              For those who keep their integrity even when it costs them.<br />
              For those who refuse to let darkness decide who they become.
            </span>
          </p>
          <p>
            And if something stirs inside you while reading these pages,<br />
            that is not by chance.
          </p>
          <p>
            <span className="italic">
              That is the shadows, gently asking to be heard.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}